@import '../../global/utility/responsive/responsive-mixins';

$sizes: 1200, 600;

:host {
  @include responsive($sizes);

  display: block;

  .map {
    display: none;
  }

  .list {
    position: relative;
    height: 100%;

    li {
      display: grid;
      grid-template-columns: 1fr 60px;

      .distance {
        text-align: right;
      }

      padding-block-end: 16px;
    }

    .show-all-link {
      margin-top: 16px;
    }
  }

  .missing-consent {
    min-height: 400px;
  }

  .info-window {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-areas:
      'img name'
      'img address'
      'img link';
    gap: 10px;

    ui-headline {
      grid-area: name;
    }

    ui-paragraph {
      grid-area: address;
    }

    ui-link {
      grid-area: link;
    }

    img {
      grid-area: img;
    }
  }
}

@include min-width($sizes, 600) {
  .list {
    display: none;
  }

  .map {
    position: relative;
    display: block;
    width: 100%;
    aspect-ratio: 16/9;
  }

  .gm-ui-hover-effect {
    /* stylelint-disable declaration-no-important */
    max-width: none !important;
    opacity: 1;
  }

  .gm-ui-hover-effect span {
    content: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M19%206.41L17.59%205%2012%2010.59%206.41%205%205%206.41%2010.59%2012%205%2017.59%206.41%2019%2012%2013.41%2017.59%2019%2019%2017.59%2013.41%2012z%22/%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%3C/svg%3E');
  }
}
